// extracted by mini-css-extract-plugin
module.exports = {"activityPage":"activityPage__4cDvs","tabs":"tabs__iIN6T","pageHeader":"pageHeader__pnnqt"};